import { off, on } from 'delegated-events';

/**
 * Run a callback only once if a user starts using a form (e.g. changing an input or submitted a form).
 * @param form The HTMLFormElement that is being used.
 * @param callback A callback function, normally used to push an analytics event.
 * @param controlEventType The control event type used to determine if a user interacting with a control. Defaults to 'change'.
 * @param controlQuerySelector A query selector used to select controls. Defaults to 'input, textarea, select'.
 * @param formEventType The form event type used to determine if a user is interacting with the form. Defaults to 'submit'.
 */
export default function formIntent(
	form: Element,
	callback: (ev?: Event) => any,
	controlEventType = 'change',
	controlQuerySelector = 'input, textarea, select',
	formEventType = 'submit'
) {
	// Only run the callback once.
	let hasStartedForm = false;

	on(controlEventType, controlQuerySelector, (ev: Event) => {
		off(controlEventType, controlQuerySelector, this);

		// Don't run the callback if it has already been started.
		if (hasStartedForm) {
			return;
		}

		hasStartedForm = true;

		callback(ev);
	});

	form.addEventListener(formEventType, function (ev: Event) {
		// Remove event listener to prevent multiple event listener callbacks.
		form.removeEventListener(formEventType, this as any);

		// Don't run the callback if it has already been started.
		if (hasStartedForm) {
			return;
		}

		hasStartedForm = true;

		callback(ev);
	});
}
